module.exports = "/images/death-of-loved-one.png?2244d4feaccacf050cefd9ee3e8aa9d4";